import { render, staticRenderFns } from "./FormTextAreaCounter.vue?vue&type=template&id=01847206"
import script from "./FormTextAreaCounter.vue?vue&type=script&lang=js"
export * from "./FormTextAreaCounter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports